<template>
  <div>
    <!-- discount form -->
    <div class="grid grid-cols-2" v-for="(discount, index) in discountRows" :key="index">
      <!-- inputs -->
      <div class="border-right">
        <div class="flex items-center justify-between mt-5 mx-48">
          <div class="grid grid-cols-2 gap-4 mx-auto">
            <!-- discount name -->
            <div>
              <vs-input
                icon="icon icon-edit"
                placeholder="Enter Discount Name"
                type="text"
                icon-pack="feather"
                icon-after="true"
                class="w-full"
                :name="'DiscountName_' + index"
                v-model="discount.name"
                :vid="index"
                v-validate="'required'"
                data-vv-as="DiscountName"
              />
              <span class="text-danger text-sm" v-show="errors.has('DiscountName_' + index)">{{ errors.first('DiscountName_' + index) }}</span>
            </div>
            <div>
              <vs-input
                icon="icon icon-percent"
                placeholder="Enter Discount Percentage"
                type="number"
                step="0.01"
                icon-pack="feather"
                icon-after="true"
                class="w-full"
                :name="'DiscountPercentage_' + index"
                v-model="discount.value"
                max-number="100"
                :vid="index"
                v-validate="'required'"
                data-vv-as="DiscountPercentage"
              />
              <span class="text-danger text-sm" v-show="errors.has('DiscountPercentage_' + index)">{{ errors.first('DiscountPercentage_' + index) }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- checkboxes -->
      <div>
        <div class="flex items-center justify-evenly mt-3 relative">
          <vs-checkbox class="mt-4" color="primary" v-model="discount.city_tax"></vs-checkbox>
          <vs-checkbox class="mt-4" color="primary" v-model="discount.county_tax"></vs-checkbox>
          <vs-checkbox class="mt-4" color="primary" v-model="discount.state_tax"></vs-checkbox>
          <vs-button v-if="index > 0" class="absolute top-0 right-0 mr-12 bg-red-600" @click="removeDiscountrow(index)" icon-pack="feather" icon="icon-trash" type="relief" color="danger" />
        </div>
      </div>
    </div>

    <!-- add new discount form -->
    <div class="mt-5">
      <vs-button class="mx-auto rounded-full vs-con-loading__container" :disabled="loading" @click="appendAddForm()" icon-pack="feather" icon="icon-plus" type="relief" />
    </div>

    <!-- add new discount form -->
    <div class="mt-5 text-center">
      <vs-button class="vs-con-loading__container" type="relief" :disabled="!saveOwnDiscountDisabled || loading" @click="saveDiscounts()">Save</vs-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AddDiscountSetUp',
  data() {
    return {
      discountRows: [
        {
          name: '',
          type: 'user',
          value: '',
          city_tax: false,
          county_tax: false,
          state_tax: false
        }
      ]
    }
  },

  // computed
  computed: {
    ...mapState('setting', ['loading']),

    // validate discount
    saveOwnDiscountDisabled() {
      return !this.errors.any()
    }
  },

  // methods
  methods: {
    ...mapActions('setting', ['addOrUpdateSystemDiscountAndTaxSetup']),

    // add new discount row
    appendAddForm() {
      this.discountRows.push({
        name: '',
        type: 'user',
        value: '',
        city_tax: false,
        county_tax: false,
        state_tax: false
      })
    },

    // remove discount row
    async removeDiscountrow(index) {
      this.discountRows.splice(index, 1)
    },

    // save discount
    async saveDiscounts() {
      if (!(await this.$validator.validate())) {
        return false
      }

      try {
        const { message } = await this.addOrUpdateSystemDiscountAndTaxSetup({ items: this.discountRows })

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.$emit('tax-and-discount-added')
        // reset the form
        Object.assign(this.$data, (this.discountRows = [{ name: '', type: 'user', value: '', city_tax: false, county_tax: false, state_tax: false }]))
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  }
}
</script>

<style scoped>
.border-right {
  border-right: 2px solid black;
}
</style>